module.exports = __webpack_public_path__ + "img/rr3.9725c66d.png";